import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Container, Row, Spinner, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
import { useLocation } from "react-router-dom";
import fileDownload from 'js-file-download';
import moment from "moment";
import PubSub from 'pubsub-js';
import Main from "../layout/Main";

import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import InfoPill from "../InfoPill";
import Confirm from "../Confirm";
import trasportApi from "../../api/trasportApi";

const BackupList = () => {
  //eslint-disable-next-line
  const location = useLocation();
  //eslint-disable-next-line
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  // const[contact,setContact] = useState(location.state ? location.state : {});
  const [lead, setLead] = useState();
  const [downloading, setDownloading] = useState(false);
  const [file, setFile] = React.useState('');
  //eslint-disable-next-line
  const [leadStatusArray, setleadStatusArray] = useState(JSON.parse(localStorage.getItem('lead_status')));

  useEffect(() => {

    async function init() {
      // const backups = await trasportApi.fetchBackups();
      const backups = null;

      if (backups) {
        setBody(backups);
        setLead(backups);
      } else {
        setBody([]);
        setLead([]);
      }
    }
    init();

  }, []);
  //eslint-disable-next-line
  const onFilterType = (event) => {
    if (event.target.value === "") {
      setBody(lead);
    } else {
      setBody(//eslint-disable-next-line
        lead.filter((data) => {
          if (
            (data.leadstatus || "").toLowerCase() ===
            (event.target.value || "").toLowerCase()
          ) {
            return data;
          }
        })
      );
    }
  };

  const handleDelete = (row) => {
    setModalShow(true);
    setFile(row);
  }
  //eslint-disable-next-line
  const getStatusClass = (status) => {//eslint-disable-next-line
    let accessStatusRec = leadStatusArray.filter((value, index, array) => {
      if (value.label === status) {

        return true
      }

    });
    if (accessStatusRec && accessStatusRec.length > 0) {

      if (accessStatusRec[0].is_converted === true) {
        return 'success';
      } else if (accessStatusRec[0].is_lost === true) {
        return 'secondary';
      } else {
        return 'primary';
      }
    } else {
      return 'secondary';
    }
  }

  const downloadFile = async (row) => {
    setDownloading(true);

    const result = await trasportApi.downloadBackupFile(row.name);
    if (result) {
      fileDownload(result, row.name);
      setDownloading(false);
    }
  }

  // Create table headers consisting of 4 columns.
  const header = [
    {
      title: "File Name",
      prop: "name",
      isFilterable: true, isSortable: true
    },
    {
      title: "File Created", prop: "ctime", isFilterable: true, cell: (row) => (
        <>
          {moment(row.fileStats.ctime).format('YYYY-MM-DD hh:mm a')}
        </>
      ),
    },
    {
      title: "File Size", prop: "size", isFilterable: true, cell: (row) => (
        <>
          {parseFloat(row.fileStats.size / 1000000).toFixed(2) + ' MB'}
        </>
      )
    },
    {
      title: 'Actions', prop: 'id', cell: (row) => (
        <>

          <Button className='btn-sm mx-2' variant='danger' onClick={() => downloadFile(row)} ><i className="fa-solid fa-download"></i></Button>
          <Button className='btn-sm mx-2' variant='danger' onClick={() => handleDelete(row)} ><i className="fa-regular fa-trash-can"></i></Button>
        </>
      )
    }

  ];

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const handleSubmit = async (e) => {
    setDownloading(true);
    // let result = await trasportApi.createBackup(lead);
    let result = null;

    if (result?.success) {
      PubSub.publish('RECORD_SAVED_TOAST', { title: 'Backup Created', message: 'Backup created successfully' });
      setTimeout(() => {

        init();
      }, 1500)

    } else {
      PubSub.publish('RECORD_ERROR_TOAST', { title: 'Backup Error', message: 'Some error occured' });
      setDownloading(false);
    }

    async function init() {
      // const backups = await trasportApi.fetchBackups();
      const backups = null;
      setDownloading(false);
      if (backups) {
        setBody(backups);
        setLead(backups);
      } else {
        setBody([]);
        setLead([]);
      }
    }

  };

  const deleteFile = async () => {
    // const result = await trasportApi.deleteBackupFile(file.name);
    const result = null;
    setModalShow(false);
    if (result?.success) {
      const newArray = body.filter(object => {

        return object.name !== file.name;

      });

      setBody(newArray);
    }
  }


  return (
    <Container>
      <Row className="">
        {modalShow &&
          <Confirm
            show={modalShow}
            onHide={() => setModalShow(false)}
            deleteFile={deleteFile}
            title="Confirm delete?"
            message="You are going to delete the record. Are you sure?"
            table="file"
          />}

        <Col lg={12} className="px-4 mt-4">

          <Alert variant="warning">
            Backup files are stored on server upto 7 days. Please download before delete.
          </Alert>
          <DatatableWrapper
            body={body}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 15,
                options: [5, 10, 15, 20],
              },
            }}
          >
            <Row className="">
              <Col
                xs={12}
                lg={4}
                className="d-flex flex-col justify-content-end align-items-end"
              >
                <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
              </Col>
              <Col
                xs={12}
                sm={6}
                lg={5}
                className="d-flex flex-col justify-content-start align-items-center"
              >
                <PaginationOptions labels={labels} />

                {/* <InfoPill left="Total" right={body?.length} /> */}
                {downloading && <button className="btn btn-warning mt-4" type="button" disabled>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Processing...
                </button>}
              </Col>
              <Col
                xs={12}
                sm={6}
                lg={3}
                className="d-flex flex-col justify-content-end align-items-end"
              >

                <Button
                  size="sm"
                  className="btn-create"
                  onClick={() => handleSubmit(true)}
                >
                  New Backup
                </Button>
                {/* <Button className="btn-sm" variant="outline-primary" onClick={()=>location.state ? navigate(`/contacts/${contact.id}`) : navigate('/contacts/')}>Back to Contact</Button> */}
              </Col>
            </Row>
            {/* {body ? ( */}
            <Table striped className="shadow rounded sm my-4" responsive={true}>
              <TableHeader classes={{ th: 'bg-custom text-white' }} />
              {
                (body && Array.isArray(body)) ?
                  <TableBody />
                  :
                  <tbody className="">
                    <tr>
                      <td colSpan={100} align="center">
                        <div>
                          <Spinner />
                        </div>
                      </td>
                    </tr>
                  </tbody>
              }
            </Table>
            {/* ) : (
                <ShimmerTable row={10} col={8} />
              )} */}

            <Pagination classes={{ buttonGroup: "", button: "bg-custom border-white" }} />
          </DatatableWrapper>
        </Col>
        <Col lg={2}></Col>
      </Row>
    </Container>

  );
};
export default BackupList;
